(() => {
  const timer = document.querySelector('[data-nobl-b6-timer]');
  if (!timer || timer.dataset.running) return;
  timer.dataset.running = 'true';
  // Match the live store countdown: the visitor's next local midnight.
  const tick = () => {
    const now = new Date();
    const nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const remaining = Math.max(0, Math.floor((nextMidnight.getTime() - now.getTime()) / 1000));
    const values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60};
    for (const [unit,value] of Object.entries(values)) timer.querySelector(`[data-time="${unit}"]`).textContent = String(value).padStart(2,'0');
  };
  tick();
  const interval = setInterval(tick,1000);
  addEventListener('pagehide',() => clearInterval(interval),{once:true});
})();

// Keep dot navigation in sync with the native gallery and its variant replacement.
(() => {
  function initGallery() {
    const gallery = document.querySelector('.nobl-b6-product media-gallery, .nobl-b6-offer-product media-gallery');
    if (!gallery || gallery.dataset.b6Ready) return;
    gallery.dataset.b6Ready = 'true';
    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    const list = gallery.querySelector('.product__media-list');
    const slides = [...list.querySelectorAll(':scope > .product__media-item')];
    if (!viewer || !slides.length) return;
    const nav = document.createElement('div');
    nav.className = 'nobl-b6-dots';
    nav.setAttribute('aria-label','Product images');
    function show(index) {
      index = Math.max(0,Math.min(index,slides.length-1));
      slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===index));
      if(list.scrollWidth>list.clientWidth+10) list.scrollTo({left:slides[index].offsetLeft-slides[0].offsetLeft,behavior:'smooth'});
      gallery.querySelectorAll('.thumbnail-list__item').forEach(item=>{
        const button=item.querySelector('button');
        if(button) button.setAttribute('aria-current',String(item.dataset.target===slides[index].dataset.mediaId));
      });
      sync();
    }
    gallery.addEventListener('click',event=>{
      const item=event.target.closest('.thumbnail-list__item');
      if(item){event.preventDefault();event.stopImmediatePropagation();show(slides.findIndex(slide=>slide.dataset.mediaId===item.dataset.target));}
      const arrow=event.target.closest('.product_gallery--button');
      if(arrow){event.preventDefault();event.stopImmediatePropagation();show(slides.findIndex(slide=>slide.classList.contains('is-active'))+(arrow.name==='previous'?-1:1));}
    },true);
    const dots = [];
    const zoom = gallery.querySelector('.product-gallery__zoom-button');
    if (zoom) viewer.append(zoom);
    function sync() {
      let index = slides.findIndex(slide=>slide.classList.contains('is-active'));
      if (list.scrollWidth > list.clientWidth + 10) index = Math.round(list.scrollLeft / list.clientWidth);
      dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
    }
    const observer = new MutationObserver(sync);
    observer.observe(list,{subtree:true,attributes:true,attributeFilter:['class']});
    list.addEventListener('scroll',sync,{passive:true});
    viewer.addEventListener('slideChanged',sync);
    gallery.addEventListener('nobl:dispose',()=>observer.disconnect(),{once:true});
    sync();
  }
  initGallery();
  document.addEventListener('nobl:gallery-updated',initGallery);
})();

// Arm 1: keep the same countdown above the gallery on mobile and in the desktop product column.
(() => {
  const timer = document.querySelector('[data-nobl-b6-timer]');
  const info = document.querySelector('.nobl-b6-product[data-nobl-arm="1"] .product__info-container');
  if (!timer || !info || timer.dataset.desktopPlacement) return;
  timer.dataset.desktopPlacement = 'true';
  const home = timer.parentNode;
  const anchor = document.createComment('Arm 1 mobile countdown position');
  home.insertBefore(anchor, timer);
  const desktop = matchMedia('(min-width: 990px)');
  const place = () => {
    if (desktop.matches) info.prepend(timer);
    else home.insertBefore(timer, anchor.nextSibling);
  };
  desktop.addEventListener('change', place);
  place();
})();


// Arm 2: retain the original offer and live variant bindings in both layouts.
(() => {
  const info = document.querySelector('.nobl-b6-product[data-nobl-arm="2"] .product__info-container');
  const offer = document.querySelector('.nobl-you-pay-section-wrapper');
  if (!info || !offer || offer.dataset.desktopPlacement) return;
  offer.dataset.desktopPlacement = 'true';
  const home = offer.parentNode;
  const anchor = document.createComment('Arm 2 mobile offer position');
  home.insertBefore(anchor, offer);
  const desktop = matchMedia('(min-width: 990px)');
  const place = () => {
    if (desktop.matches) info.prepend(offer);
    else home.insertBefore(offer, anchor.nextSibling);
  };
  desktop.addEventListener('change', place);
  place();
})();

